const imageSizes = {
  standardWidths: {
    '320w': {
      r: {
        width: 320
      }
    },
    '480w': {
      r: {
        width: 480
      }
    },
    '660w': {
      r: {
        width: 660
      }
    },
    '768w': {
      r: {
        width: 768
      }
    },
    '960w': {
      r: {
        width: 960
      }
    },
    '1280w': {
      r: {
        width: 1280
      }
    }
  },
  '16:9': {
    '320w': {
      r: {
        width: 320,
        height: 180
      }
    },
    '480w': {
      r: {
        width: 480,
        height: 270
      }
    },
    '660w': {
      r: {
        width: 660,
        height: 371
      }
    },
    '768w': {
      r: {
        width: 768,
        height: 432
      }
    },
    '960w': {
      r: {
        width: 960,
        height: 540
      }
    },
    '1280w': {
      r: {
        width: 1280,
        height: 720
      }
    }
  }
};

const RESPONSIVE_IMAGE_CONFIG = process.env.DISABLE_RESPONSIVE_IMAGES
  ? null
  : {
      sizes: {
        socialMeta: {
          single: {
            r: {
              width: 1280
            }
          }
        },
        image: {
          widths: imageSizes.standardWidths,
          sizes: '100vw'
        },
        'card:portrait:grid--one:no-resize': {
          widths: imageSizes.standardWidths,
          sizes: '100vw'
        },
        'card:portrait:grid--two:no-resize': {
          widths: imageSizes.standardWidths,
          sizes: '100vw'
        },
        'card:portrait:grid--three:no-resize': {
          widths: imageSizes.standardWidths,
          sizes: '100vw'
        },
        'card:portrait:grid--four:no-resize': {
          widths: imageSizes.standardWidths,
          sizes: '100vw'
        },
        'card:landscape:grid--one:no-resize': {
          widths: imageSizes.standardWidths,
          sizes: '100vw'
        },
        'card:landscape:grid--two:no-resize': {
          widths: imageSizes.standardWidths,
          sizes: '100vw'
        },
        'card:landscape:grid--three:no-resize': {
          widths: imageSizes.standardWidths,
          sizes: '100vw'
        },
        'card:landscape:grid--four:no-resize': {
          widths: imageSizes.standardWidths,
          sizes: '100vw'
        },
        'card:landscape:grid--one:sidebar-card': {
          widths: {
            '320w': imageSizes['16:9']['320w'],
            '660w': imageSizes['16:9']['660w']
          },
          sizes: '(max-width: 960px) 40vw, 10vw'
        },

        'card:portrait:grid--two': {
          widths: imageSizes['16:9'],
          sizes: '(max-width: 768px) 100vw, 50vw'
        },
        'card:portrait:grid--three': {
          widths: imageSizes['16:9'],
          sizes: '(max-width: 768px) 100vw, 33vw'
        },
        'card:portrait:grid--four': {
          widths: imageSizes['16:9'],
          sizes: '(max-width: 768px) 50vw, 25vw'
        },
        'card:landscape:grid--two': {
          widths: imageSizes['16:9'],
          sizes: '(max-width: 768px) 40vw, 10vw'
        },
        'card:landscape:grid--one': {
          widths: imageSizes['16:9'],
          sizes: '40vw'
        },
        // company image on company listing
        'card:portrait:grid--four:company': {
          widths: imageSizes.standardWidths,
          sizes: '(max-width: 660px) 100vw, 20vw'
        },
        // featured company image on company listing
        'card:portrait:grid--one:company': {
          widths: imageSizes.standardWidths,
          sizes: '(max-width: 660px) 100vw, 20vw'
        },
        // popular parts (categories) on homepage
        'card:landscape:grid--four:image-right__border-rounded popular-categories': {
          widths: imageSizes.standardWidths,
          sizes: '(max-width: 1024px) 40vw, 20vw'
        },
        'card:landscape:grid--two:image-right__border-rounded popular-categories card--clickable': {
          widths: imageSizes.standardWidths,
          sizes: '(max-width: 1024px) 40vw, 20vw'
        },
        ecommerce_basket: {
          widths: imageSizes['16:9'],
          sizes: '25vw'
        },
        ecommerce_review: {
          widths: imageSizes['16:9'],
          sizes: '25vw'
        },
        ecommerce_flyout_basket: {
          widths: imageSizes['16:9'],
          sizes: '10vw'
        },
        card: {
          widths: imageSizes['16:9'],
          sizes: '100vw'
        },
        globalLightbox: {
          widths: imageSizes.standardWidths,
          sizes: '100vw'
        },
        carousel: {
          widths: imageSizes['16:9'],
          sizes: '100vw'
        }
      }
    };

export { RESPONSIVE_IMAGE_CONFIG };
